module.exports = __webpack_public_path__ + "static/media/Stellar Ark King Headboard - 180 cm_Grey.fbf958f2.png";